import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { clearAuthToken, setAuthToken } from "~/modules/authentication"

export function useLogout() {
  const navigate = useNavigate()

  return useCallback(() => {
    clearAuthToken()
    navigate("/login")
  }, [navigate])
}
